module.exports = __webpack_public_path__ + "static/img/syy.8ab9d36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/syy.png
// module id = sdje
// module chunks = 0